/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

$(document).ready(function () {
  if ($(".model-stats").length > 0) {
    console.log("HAS MODEL STATS");
    $(".model-stats").show();
    $(".product__accordion.models-stats").show();
    $(".product__accordion__inner.rte.models-stats").append($(".model-stats"));
    document.querySelector('.product__accordion__inner.rte.models-stats>p').style.display = 'none'; {
}
  }
});

/*
document.addEventListener('DOMContentLoaded', function () {
  // Ambil semua elemen .model-stats yang tersembunyi
  const modelStats = document.querySelectorAll('.model-stats');
  const accordionContent = document.querySelector(
    '.product__accordion__inner.rte.models-stats'
  );

  // Bersihkan konten default dari accordion
  accordionContent.innerHTML = '';

  // Pindahkan setiap model stat ke dalam accordion
  modelStats.forEach(stat => {
    accordionContent.appendChild(stat.cloneNode(true));
  });

  // Pastikan model stats dalam accordion terlihat
  document.querySelector('.models-stats').style.display = 'block';
  document.querySelector('.product__accordion.models-stats').style.display = 'block';
});*/
